'use strict'

module.exports = function (ngModule) {
  ngModule
  .controller('AvatarInstanceCtrl', ["$scope", "$uibModalInstance", "$timeout", "avatar", function ($scope, $uibModalInstance, $timeout, avatar) {
    var originAvatar
    $timeout(function () {
      $scope.image = {
        userAvatar: avatar,
        userAvatarImage: ''
      }
    })

    $scope.avatarOnChange = function ($dataURI) {
      $log.debug($dataURI)
    }

    $scope.ok = function () {
      $uibModalInstance.close($scope.image.userAvatarImage)
    }
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }
  }])
  .controller('ModalInstanceCtrl', ["$scope", "$uibModalInstance", "displayData", function ($scope, $uibModalInstance, displayData) {
    $scope.modal = displayData

    $scope.ok = function () {
      $uibModalInstance.close()
    }
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }
  }])
  .controller('ResetInstanceCtrl', ["$scope", "$timeout", "$uibModalInstance", "PgApi", function ($scope, $timeout, $uibModalInstance, PgApi) {
    $scope.alert = {
      type: '',
      message: ''
    }
    $scope.reset = {
      mode: 'reset'
    }

    $scope.resetAlert = function () {
      $scope.alert = {
        type: '',
        message: ''
      }
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }

    $scope.sendPwdReset = function (userEmail) {
      PgApi.reqResetPwd(userEmail)
      .then(function (resp) {
        $scope.reset.mode = 'finish'
      })
      .catch(function (err) {
        $scope.alert = {
          type: 'danger',
          message: err.msg
        }
      })
    }
  }])
}



//////////////////
// WEBPACK FOOTER
// ./js/controllers/modal.js
// module id = 51
// module chunks = 0